import { IGetterFn } from '@/store/types';

/**
 * 验收列表的 tab 页签
 * 除了 `text` 字段外，其他字段都是搜索接口需要的字段，用于搜索
 * 0: 删除; 1: 新建; 2: 取消; 3: 完成; 4: 预约
 * @property {string} text - tab页签上显示的文本
 * @property {number} status - 验收状态
 */
export const tabItems: IGetterFn = () => {
  return [
    { text: '我的需求', statuses: [1, 4] },
    { text: '历史需求', statuses: [2, 3] },
  ];
};
